'use client';

import type { HeadingLevelOption, ThingsToKnowBlock } from './types';
import Icon from '../icon/icon';
import { resolveHeadingLevel } from '../rich-text-title';
import BevSafeText from '../bev-safe-text';

type DescriptionBlockProps = {
	block: ThingsToKnowBlock;
	headingLevel?: HeadingLevelOption;
};

export default function DescriptionBlock({ block, headingLevel }: DescriptionBlockProps) {
	const icon = block.type === 'cancellationPolicy' ? 'no_available_date' : block.icon;

	// BL AC: default to H3, author may override. The `text-h3` styling the UI AC
	// asks for is kept regardless of the tag chosen.
	const TitleTag = resolveHeadingLevel(headingLevel, 'h3');

	return (
		<div className="flex flex-col spacing-stack-l">
			<div className="border-t border-border-subtle" />

			<div className="flex flex-col spacing-stack-s">
				<div className="flex flex-row items-start spacing-inline-s">
					<Icon icon={icon} className="text-[24px] leading-none text-text-primary lg:text-[30px]" />
					<TitleTag className="text-h3 text-text-heading">
						<BevSafeText>{block.title}</BevSafeText>
					</TitleTag>
				</div>

				{block.body.length > 0 && (
					<ul className="list-disc ps-[24px]">
						{block.body.map((item, index) => (
							<li
								key={index}
								className="text-body2 text-text-primary"
								dangerouslySetInnerHTML={{ __html: item }}
							/>
						))}
					</ul>
				)}
			</div>
		</div>
	);
}
